import { getData } from "@/utils/fetch";
import debounce from "debounce-promise";
import { defineStore } from "pinia";

let debouncedFetch = debounce(getData, 500);

export const usesgnksoFeaturesStore = defineStore({
  id: "sgnksofeatures",
  state: () => ({
    sgnkso_features: {},
    featurebyid: {},
    sgnbykodepetak: {},
    featurebydate: {},
    loading: false,
  }),
  getters: {
    getData(state) {
      return state.sgnkso_features.data;
    },
  },
  actions: {
    async getAllSgnksofeatures(params) {
      this.sgnkso_features = { loading: true };
      const dataparams = {
        limit: params?.limit || 50,
        offset: params?.offset || 0,
      };

      try {
        const result = await debouncedFetch("sgn_kso_features", dataparams);
        this.sgnkso_features = { ...result.data };
        console.log(this.sgnkso_features);
      } catch (error) {
        console.log(error);
        this.sgnkso_features = { error };
      }
    },

    async getByFeatureid(featureid) {
      try {
        this.loading = true;
        const result = await debouncedFetch("sgn_kso_features/" + featureid);
        this.featurebyid = { ...result.data };
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
        this.featurebyid = { error };
      }
    },

    async getByKodePetak(kodepetak) {
      this.sgnbykodepetak = { loading: true };

      try {
        const result = await debouncedFetch(
          "sgn_kso_features/bykodepetak/" + kodepetak
        );
        this.sgnbykodepetak = { ...result.data };
      } catch (error) {
        console.log(error);
        this.sgnbykodepetak = { error };
      }
    },

    async getByDate(kodepetak, date) {
      this.featurebydate = { loading: true };
      try {
        const result = await debouncedFetch(
          `sgn_kso_features/bydate/${kodepetak}/${date}`
        );
        this.featurebydate = { ...result.data };
      } catch (error) {
        console.log(error);
        this.featurebydate = { error };
      }
    },
  },
});
